export const title = 'Forbidden';
export const subTitle = 'Please try again or contact support';
export const subTitleLink = 'Go back';
export const linkText = 'With any question or concern - ';
export const contactSupportLinkText = 'contact support';
